/****************************************************************************
 * Copyright 2021 EPAM Systems
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 ***************************************************************************/

import styled from '@emotion/styled';
import { style } from '../styles';

export const StyledInput = styled.input({
  border: 'none',
  borderRadius: style.border.radius.medium,
  outline: style.border.primary,
  padding: '4px 8px',
  caretColor: style.color.green,

  ':hover': {
    outline: style.border.medium,
  },

  ':active, :focus,:focus-visible': {
    outline: style.border.secondary,
  },

  ':disabled': {
    color: 'blue',
    outline: style.border.primary,
    backgroundColor: '#e1e5ea',
  },
});
